import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import PaperMUI from '@material-ui/core/Paper';
import classNames from 'classnames';
import { toCssValue } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    root: {
        boxShadow: theme.common.shadow.default,
        borderRadius: theme.common.borderRadius.default,
        padding: theme.space.padding.default,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        alignItems: 'normal',
        boxSizing: 'border-box',
    },
    noPadding: {
        padding: 0,
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        backgroundColor: theme.components.table.header.background,
        color: theme.components.table.header.color,
        fontFamily: theme.font.family,
        fontWeight: theme.font.weight.bold,
        borderRadius: '5px 5px 0 0',
        margin: 0,
        padding: toCssValue([theme.space.padding.smallest, theme.space.padding.default]),
        boxSizing: 'border-box',
        minHeight: theme.font.size.medium * 3,
    },
    content: {
        padding: theme.space.padding.default,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
    },
});
const Panel = (props) => {
    const { classes, className: classNameProp, header, children, testId = 'Panel', ...other } = props;
    const className = classNames(classes.root, header ? classes.noPadding : null, classNameProp);
    if (header) {
        return (React.createElement(PaperMUI, Object.assign({ "data-testid": testId, className: className }, other),
            React.createElement("div", { "data-testid": `${testId}-header`, className: classes.header }, header),
            React.createElement("div", { "data-testid": `${testId}-content`, className: classes.content }, children)));
    }
    else {
        return (React.createElement(PaperMUI, Object.assign({ className: className }, other), children));
    }
};
const ComposedPanel = compose(withStyles(styles, { withTheme: true }), pure)(Panel);
ComposedPanel.displayName = 'Panel';
export default ComposedPanel;
//# sourceMappingURL=Panel.js.map